<template>
  <div id="app">
    <!-- 头部组件 -->
    <div class="header">
      <div class="headerbox">
        <div>
          <img class="topImg" src="@/assets/imgs/toplogo-sign.png" alt />
        </div>
        <div class="rightBox">
          <el-button @click="freshUrl" size="mini" type="primary">更新到最新版本</el-button>
          <el-dropdown trigger="click" @command="handleOpenDialog">
            <span class="el-dropdown-link tophelp">
              帮助与反馈
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="downlist">
              <el-dropdown-item command="0">联系客服</el-dropdown-item>
              <!-- <el-dropdown-item command="1">意见反馈</el-dropdown-item> -->
              <el-dropdown-item>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <img class="userImg" v-if="avatar" :src="avatar" :onerror="defaultAvatarImgae" alt />
          <img class="userImg" v-else src="../../assets/imgs/hello.png" alt />
          <span class="topusername">{{nickname}}</span>
        </div>
      </div>
    </div>
    <!-- 联系客服弹窗 -->
    <div class="onebox">
      <el-dialog
        title="联系客服"
        :visible.sync="isShowContact"
        width="22%"
        center
        style="border-radius:8px;"
        class="showBox"
      >
        <div class="contactBox">
          <div class="leftimg">
            <img src="@/assets/imgs/hello.png" alt />
          </div>
          <div class="rightText">
            <p>客服电话 : 13524808972</p>
            <p>如您在使用过程中遇到任何问题，请联系我们的工作人员。</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer contactFooter">
          <el-button type="primary" @click="isShowContact = false">知道了</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 意见反馈弹窗 -->
    <div class="onebox">
      <el-dialog
        title="意见反馈"
        :visible.sync="isShowFeedback"
        width="22%"
        center
        style="border-radius:8px;"
        class="showBox"
      >
        <div class="FeedbackBox">
          <p style="color:#666;font-szie:14px;margin-bottom:7px;">意见描述</p>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入100字以内的反馈"
            v-model="FeedbackBoxText"
            maxlength="100"
            show-word-limit
            resize="none"
          ></el-input>
        </div>
        <span slot="footer" class="dialog-footer Feedbackfooter">
          <el-button @click="isShowFeedback = false">取 消</el-button>
          <el-button type="primary" @click="handleSendFeedback">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import PublicApi from "@/api/PublicModule";
import { removeToken, removeTime } from '@/utils/auth'
export default {
  data() {
    return {
      defaultAvatarImgae:'this.src="' + require("../../assets/imgs/hello.png") + '"',
      avatar:'',
      // 联系客服弹窗是否显示
      isShowContact: false,
      // 意见反馈弹窗是否显示
      isShowFeedback: false,
      // 意见反馈内容
      FeedbackBoxText: "",
      nickname:''
    };
  },
  methods: {
    freshUrl(){
      var urladd = window.location.href;
      if(urladd.indexOf("?") != -1){
        urladd = urladd.split("?")[0];
      }
      var timestamp = Date.parse(new Date());
      window.location.href = urladd+'?fresh='+timestamp;
      location.reload();
    },
    transForm(){
      var downlist = document.getElementsByClassName('downlist')[0];
      var eliconright = document.getElementsByClassName('el-icon--right')[0];
      if(downlist.style.display==="none"){
        eliconright.style.transform = "rotate(180deg)";
      }else{
        eliconright.style.transform = "rotate(360deg)";
      }
    },
    handleOpenDialog(e) {
      if (e === "0") {
        this.isShowContact = true;
        this.isShowFeedback = false;
      } else if(e==="1") {
        this.isShowContact = false;
        this.isShowFeedback = true;
        this.FeedbackBoxText = "";
      }else{
        removeToken()
        removeTime()
        localStorage.setItem('isLogin','2');
        localStorage.removeItem('account');
        this.$router.push({
            path:"/login"
        })
      }
    },
    // 提交的反馈内容
    handleSendFeedback() {
      let params = {
        source: "pc",
        content: this.FeedbackBoxText,
        token: ""
      };
      PublicApi.sendFeedback(params)
        .then(res => {
          // 关闭弹窗
          this.isShowFeedback = false;
          // 提示用户提交成功
        })
        .catch(err => {
          console.log(err);
        });
    },
    account(){
      var that = this;
      var account = JSON.parse(localStorage.getItem('account'))||{};
      that.nickname =account.nickname;
      that.avatar = account.avatar
    }
  },
  mounted(){}
};
</script>
<style scoped>

.header {
  width: 100%;
  min-width: 1280px;
  height: 50px;
  background-color: #003068;

}
.headerbox {
  width: 1280px;
  height: 100%;
  min-width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
    box-sizing: border-box;
  padding: 0 20px;
}
.headerbox .topImg {
  width: 94px;
  height: 22px;
  margin-top: 14px;
}
.headerbox .topusername {
  line-height: 50px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
.headerbox .userImg {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  border-radius: 50%;
}
.header .tophelp {
  line-height: 50px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
.header .tophelp:hover {
  color: #0077ff;
}
.contactBox {
  display: flex;
}
.contactBox .leftimg {
  width: 118px;
  height: 137px;
  margin-right: 23px;
}
.contactBox .leftimg img {
  width: 113px;
  height: 114px;
}
.contactBox .rightText {
  width: 212px;
}
.contactBox .rightText p:first-child {
  font-size: 16px;
  color: rgba(51, 51, 51, 1);
  margin-top: 28px;
  margin-bottom: 10px;
}
.contactBox .rightText p:last-child {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
}
</style>
<style>
.onebox .el-dialog--center {
  min-width: 453px;
}
.el-dropdown-menu__item {
  font-size: 12px;
}
.showBox .el-dialog__body {
  padding-bottom: 0 !important;
}
.el-dialog__footer {
  padding-bottom: 30px;
  padding-top: 40px;
}
.contactFooter .el-button {
  width: 116px;
  height: 35px;
  border-radius: 4px;
  line-height: 0;
}
.Feedbackfooter .el-button {
  width: 90px;
  height: 35px;
  border-radius: 4px;
  line-height: 0;
}
.el-dialog__header {
  border-bottom: 1px solid #f5f6f9;
  padding: 15px 0 12px;
}
.el-icon--right {
    margin-left: 0!important;
    transition: transform .3s,-webkit-transform .3s;
}
</style>



// WEBPACK FOOTER //
// src/components/public/Header.vue